import { render } from "./ModalArticle.vue?vue&type=template&id=b2153960"
import script from "./ModalArticle.vue?vue&type=script&lang=js"
export * from "./ModalArticle.vue?vue&type=script&lang=js"

import exportComponent from "E:\\workspace\\ef_vue_icecreator\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__